import type { VideoCategory } from '@/types/educaliec';

export const educaliecCategories: VideoCategory[] = [
  { id: 'todos', label: 'Todos', keywords: [] },
  { id: 'concreto', label: 'Concreto', keywords: ['concreto', 'cemento', 'resistencia', 'cilindros', 'planicidad', 'Contenido de Aire', 'cilíndricos' ] },
  { id: 'terracerias', label: 'Terracerías', keywords: ['terracerías', 'compactación', 'balasto', 'CBR'] },
  { id: 'acero', label: 'Acero', keywords: ['acero', 'varilla', 'medición'] },
  { id: 'asfalto', label: 'Asfaltos', keywords: ['asfalto', 'pavimento', 'mezcla asfáltica'] },
  { id: 'pnd', label: 'PND', keywords: ['pnd', 'partículas', 'riel','flexión lenta'] },
  { id: 'pruebas especiales', label: ' Pruebas Especiales', keywords: ['ion', 'pruebas especiales', 'geotextiles', 'petrográfico'] },
  { id: 'mecanica de suelos', label: 'Mecánica de Suelos', keywords: ['STP', 'penetración estandar'] },
];